/* eslint-disable prettier/prettier */
const portfolioRoutes = [
  {
    path: "/portfolio",
    name: "",
    meta: {
      title: "포트폴리오",
      isDynamic: true,
    },
    children: [
      {
        path: "reg",
        name: "student.portfolio.reg",
        meta: {
          title: "포트폴리오",
          menuCd: "PORTFOLIO",
          isDynamic: true,
        },
        component: () => import("@/views/student/portfolio/main/StudentPortfolioReg.vue"),
      },
      {
        path: "update/:id",
        name: "student.portfolio.update",
        meta: {
          title: "포트폴리오",
          menuCd: "PORTFOLIO",
            isDynamic: true,
        },
        component: () => import("@/views/student/portfolio/main/StudentPortfolioReg.vue"),
      },
      {
        path: "",
        name: "student.portfolio.list",
        meta: {
          title: "포트폴리오 목록",
          menuCd: "PORTFOLIO",
            isDynamic: true,
        },
        component: () => import("@/views/student/portfolio/main/StudentPortfolioIndex.vue"),
      },
    ],
  },
];
export default portfolioRoutes;
